"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _reactRedux = require("react-redux");

var _Button = _interopRequireDefault(require("../../components/Button"));

var _InfoboxField = _interopRequireDefault(require("../../components/InfoboxField"));

var _mapActions = require("../../actions/mapActions");

var _config = require("../../config");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ZoomToPointButton = function ZoomToPointButton(props) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var currentView = (0, _reactRedux.useSelector)(function (state) {
    return state.mapViewReducer.mapView;
  });

  var navToPoint = function navToPoint() {
    dispatch((0, _mapActions.navigateToPoint)(props));
  };

  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    title: 'Magnify/Zoom',
    disabled: currentView.zoom === _config.mapConfig.maxZoom,
    classNames: ['infobox-buttons'],
    onClick: navToPoint
  }, "Magnify/Zoom");
};

ZoomToPointButton.propTypes = {
  lat: _propTypes.default.number.isRequired,
  lng: _propTypes.default.number.isRequired
};

var getLabelName = function getLabelName(desc) {
  switch (desc.type) {
    case 'BOTH':
      return 'Number of Both Accounts Served';

    case 'JOC':
      return 'Number of Critical Accounts Served';

    case 'LCS':
      return 'Number of Managed Accounts Served';

    default:
      return 'Number of Accounts Served';
  }
};

var transformerFields = function transformerFields(desc) {
  if (desc.cluster) {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: 'infobox-body-outage'
    }, /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
      highlight: true,
      name: 'Number of Transformers',
      icon: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: ['fas', 'exclamation-triangle']
      }),
      value: desc.n_out.toString()
    }));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    id: 'infobox-body-outage'
  }, /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    highlight: true,
    name: 'Transformer ID',
    icon: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'exclamation-triangle']
    }),
    value: desc.tf_id
  }), /*#__PURE__*/_react.default.createElement(_InfoboxField.default, {
    name: getLabelName(desc),
    icon: /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'exclamation-triangle']
    }),
    value: desc.cust_s.toString()
  }));
};

var OutageInfobox = function OutageInfobox(props) {
  var outage = props.outage;
  var desc = outage.desc,
      clickedLatLng = outage.clickedLatLng;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, outage.layer && outage.layer.name === 'transformers' ? transformerFields(desc) : /*#__PURE__*/_react.default.createElement("span", null, "\xA0"), /*#__PURE__*/_react.default.createElement("div", {
    className: 'infobox-footer'
  }, /*#__PURE__*/_react.default.createElement(ZoomToPointButton, clickedLatLng)));
};

OutageInfobox.propTypes = {
  outage: _propTypes.default.any.isRequired,
  toggleFullScreen: _propTypes.default.func
};
var _default = OutageInfobox;
exports.default = _default;